import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { Header } from './components/Header';
import { ProductSelect } from './components/ProductSelect';
import { SliceInfo } from './components/SliceInfo';
import { SliceProducts } from './components/SliceProducts';

import { AnimateSpin } from '@/components/AnimateSpin';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/Tabs';
import { ROUTE_PATHS } from '@/config/constants';
import { useGetMerchandisingCollectionSlice } from '@/hooks/useGetMerchandisingCollectionSlice';

export function Slice() {
  const [tabValue, setTabValue] = useState('current');

  const params = useParams();

  const collectionId = Number(params.collectionId);
  const sliceId = Number(params.sliceId);

  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.MerchandisingCollections.pages.Slice',
  });

  const { merchandisingCollectionSlice, isLoading, isError } =
    useGetMerchandisingCollectionSlice(collectionId, sliceId);

  if (isLoading) {
    return (
      <div className="mt-10">
        <AnimateSpin />
      </div>
    );
  }

  if (isError || !merchandisingCollectionSlice) {
    return (
      <Navigate
        to={ROUTE_PATHS.MERCHANDISING_COLLECTION.replace(
          ':collectionId',
          String(collectionId),
        )}
        replace
      />
    );
  }

  return (
    <div className="container space-y-6 p-6">
      <Header slice={merchandisingCollectionSlice} />

      <SliceInfo slice={merchandisingCollectionSlice} />

      <Card>
        <CardHeader>
          <CardTitle>{t('title')}</CardTitle>
          <CardDescription>{t('description')}</CardDescription>
        </CardHeader>

        <CardContent>
          <Tabs
            value={tabValue}
            onValueChange={(value) => setTabValue(value)}
            className="w-full"
          >
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="current">
                {t('tabs.current', {
                  count: merchandisingCollectionSlice.productsCount,
                })}
              </TabsTrigger>

              <TabsTrigger value="select">{t('tabs.select')}</TabsTrigger>
            </TabsList>

            <TabsContent value="current" className="mt-6 space-y-4">
              <SliceProducts slice={merchandisingCollectionSlice} />
            </TabsContent>

            <TabsContent value="select" className="mt-6">
              <ProductSelect isSelected={tabValue === 'select'} />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
}
